import { z } from "zod";

export const subaccountSchema = z.object({
    id: z.string(),
    name: z.string(),
    financialAccountId: z.number(),
    sourceAccountId: z.string().nullable(),
    accountNumber: z.string().nullable(),
});

export type SubaccountSchema = z.infer<typeof subaccountSchema>;
